module.exports = __webpack_public_path__ + "static/media/caebes-logo.c13e4c96.svg";